import React from "react";

import { Theme, useTheme } from "@mui/material/styles";

import { logDebug, mergeProperties } from "packable-components";
import { OrderHeaderProps } from "./Order.types";
import { Grid, Typography } from "@mui/material";

const useStyles = (theme: Theme) => ({
  OrderHeaderContainer: {
    width: "512px",
    pb: 1,
    pl: 1,
    display: "flex",
    flexDirection: "column",
  },
  OrderHeaderContainerDivider: {
    mb: 2,
  },
  OrderHeaderRowContainer: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "center",
  },
  OrderHeaderSingleItemRowContainer: {
    width: "512px",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  OrderHeaderContentShortTextFieldContainer: {
    padding: 1,
  },
  OrderHeaderContentShortTextField: {
    width: "240px",
  },
  OrderHeaderContentFullWidthTextFieldContainer: {
    width: "100%",
    padding: 1,
  },
  OrderHeaderContentActionRow: {
    padding: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  OrderHeaderContentActionRemoveButton: {
    muiVariant: "contained",
    muiColor: "secondary",
  },
});

export const OrderHeader: React.FC<OrderHeaderProps> = (
  props
): React.JSX.Element => {
  const { order, styles } = props;

  logDebug("OrderHeader PROPS");
  logDebug(props);

  const theme = useTheme();

  const defaultStyles = useStyles(theme);
  const effectiveStyles =
    styles === undefined
      ? defaultStyles
      : mergeProperties(defaultStyles, styles);

  logDebug("OrderHeader effectiveStyles");
  logDebug(effectiveStyles);

  return (
    <Grid
      className="OrderHeaderContainer"
      sx={effectiveStyles.OrderHeaderContainer}
    >
      <Typography variant="body1">
        {`${order?.userFirstName} ${order?.userLastName}`}
      </Typography>
      {order?.entityName && (
        <Typography variant="body2">{`${order?.entityName}`}</Typography>
      )}
      <Typography variant="body2">
        {`${order?.fromLocation.address.addressLine1}`}
      </Typography>
      {order?.fromLocation.address.addressLine2 !== undefined &&
        order?.fromLocation.address.addressLine2 !== null &&
        order?.fromLocation.address.addressLine2.length > 0 && (
          <Typography variant="body2">
            {`${order?.fromLocation.address.addressLine2}`}
          </Typography>
        )}
      {order?.fromLocation.address.addressLine3 !== undefined &&
        order?.fromLocation.address.addressLine3 !== null &&
        order?.fromLocation.address.addressLine3.length > 0 && (
          <Typography variant="body2">
            {`${order?.fromLocation.address.addressLine3}`}
          </Typography>
        )}
      <Typography variant="body2">
        {`${order?.fromLocation.address.city}, ${
          order?.fromLocation.address.region === null ||
          order?.fromLocation.address.region === undefined
            ? ""
            : order?.fromLocation.address.region
        } ${order?.fromLocation.address.postalCode}`}
      </Typography>
    </Grid>
  );
};

export default OrderHeader;
